<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AZlh">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="JANUARY 15: Settling for Mud Pies">
<h1 class="chapter" id="pAIJd"><a href="#/contents#AB_ch16" id="AB_cha16">JANUARY 15<br/><br/> <span class="chapter2">Settling for Mud Pies</span></a></h1>
<blockquote>
<p class="ext" id="pAjN"><em>Now to Him who is able to do exceedingly abundantly above all that we ask or think, according to the power that works in us, to Him be glory in the church by Christ Jesus.</em></p>
</blockquote>
<p class="right" id="pAqqq">—Ephesians 3:20–21</p>
<p class="noind" id="pAsPY"><span class="dcap"><b>S</b></span>ometimes our thankfulness fades when we look at what other people have. Have you ever felt envious, maybe even shortchanged? At those times we can be grateful that God has so much more for us than even what our neighbor may be enjoying.</p>
<p id="pArGI">In <em>The Weight of Glory</em>, C. S. Lewis wrote: “We are half-hearted creatures, fooling about with drink and sex and ambition when infinite joy is offered us, like an ignorant child who wants to go on making mud pies in a slum because he cannot imagine what is meant by the offer of a holiday at the sea.”</p>
<p id="pAVEh">When we struggle to give thanks, maybe we are trying to muster up gratitude for mud pies when He gives us the opportunity to thank Him for vacations at the beach.</p>
<p id="pAi9c">Yes, we can thank God for many concrete blessings and for the various ways He clearly provides, protects, and answers prayers. But how often do we offer thanks because He gives us patience, helps us see people with His eyes of compassion, or grants us hope though circumstances are difficult?</p>
<p id="pAjqh">May God open our eyes to all He grants to those He loves.</p>
<p class="left1" id="pAomo"><em>I am grateful, Lord, for the blessings You bestow. Your gifts are always the best.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter16.vue?05467105